/* eslint-disable no-undef */
/* eslint-disable prefer-const */
/* eslint-disable consistent-return */
import { observable, action } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';

let cancelSequenceRequest = null;
let cancelFolderRequest = null;

class SequenceData {
  @observable sequenceData = null;

  @observable allFolderResponse = null;

  @action
  setSequenceData(value) {
    this.sequenceData = value;
  }

  @action
  setFolderResponse = value => {
    if (value) this.allFolderResponse = value;
  };

  @action
  getAllSequenceData = () => {
    const config = {
      url: URLS.salesgear.getAllSequence,
      method: 'GET',
    };
    this.checkAndcancelSeqRequest();
    makeApi(config, false, this.cancelSeqRequestCbk)
      .then(response => {
        if (response && response.data) this.setSequenceData(response.data);
      })
      .catch(error => {});
  };

  @action
  getAllSequenceFolders = async () => {
    try {
      const config = {
        url: URLS.salesgear.getAllSequenceFolders,
        method: 'GET',
      };
      this.checkAndcancelFolderRequest();
      const res = await makeApi(config, false, this.cancelFolderRequest);
      if (res && res.data) this.setFolderResponse(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  @action
  getFolderResponseById = async folderId => {
    if (folderId.length) {
      let targetURL = URLS.salesgear.getFolderSeqeunceById;
      // eslint-disable-next-line curly
      if (targetURL) {
        targetURL = targetURL.replace('<<folderId>>', folderId);
      }
      const config = {
        url: targetURL,
        method: 'GET',
      };
      this.checkAndcancelSeqRequest();
      makeApi(config, false, this.cancelSeqRequestCbk)
        .then(response => {
          if (response && response.data)
            if (response.data.length) {
              this.setSequenceData(response.data);
            } else {
              this.setSequenceData([]);
            }
        })
        .catch(error => {
          console.error('Get Folder Data error ', error);
        });
    }
  };

  @action
  getSharedSequence = async () => {
    const config = {
      url: URLS.salesgear.getSharedSequence,
      method: 'GET',
    };
    this.checkAndcancelSeqRequest();
    try {
      const res = await makeApi(config, false, this.cancelSeqRequestCbk);
      if (res && res.data) this.setSequenceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  checkAndcancelSeqRequest = () => {
    if (cancelSequenceRequest !== null) {
      cancelSequenceRequest('cancel');
      cancelSequenceRequest = null;
    }
  };

  checkAndcancelFolderRequest = () => {
    if (cancelFolderRequest !== null) {
      cancelFolderRequest('cancel');
      cancelFolderRequest = null;
    }
  };

  cancelSeqRequestCbk = value => {
    cancelSequenceRequest = value;
  };

  cancelFolderRequestCbk = value => {
    cancelFolderRequest = value;
  };
}

const sequenceStoreData = new SequenceData();
export { sequenceStoreData };
export default sequenceStoreData;
